import React from 'react'
import './index.scss'

const educations = [
  {
    school: 'Tribhuvan University, Nepal',
    name: `Bachelor's Degree in Computer Science and
    Information Technology`,

    time: 'August 2008 – December 2012'
  },
  {
    school: 'National School Of Sciences, Nepal',
    name: `High School`,

    time: 'May 2006 – June 2008'
  }
]

const Education = () => {
  return (
    <div className="education">
      <h3 className="title">Education</h3>
      <div className="school__container">
        {educations.map(education => (
          <div key={education.school} className="school">
            <p className="education__name">{education.name}</p>
            <small>{education.school}</small>
            <small>{education.time}</small>
          </div>
        ))}
      </div>
    </div>
  )
}

export default Education
